import { useContext } from "react";
import { useSearchParams } from "react-router-dom";
import { Box, Divider, Typography } from "@mui/material";

import CallIcon from "@mui/icons-material/Call";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";

import styles from "../../../../assets/styles/componentStyles/templateLibraryStyles/whatsappTemplatePreview.module.scss";

import GlobalButton from "../../../utility/globalButton/button";
import { commonButtonStyle } from "../constant";
import { getWabaName } from "../../../../utils/constants";
import { IntegrationContext, IntegrationContextPayload } from "../../../../context/integrationContext";
import { primaryColor } from "../../../../utils/colors";

interface CallPermissionRequestPreviewProps {
    wabaName?: string;
    fullWidth?: boolean;
    variant?: "default" | "primary";
}

const CallPermissionRequestPreview = (props: CallPermissionRequestPreviewProps) => {

    const { wabaName: wabaNameProp, fullWidth, variant = "default" } = props;
    
    const { integrationListNewStructure } = useContext(IntegrationContext) as IntegrationContextPayload;
    
    const [searchParams] = useSearchParams();
    const id = searchParams.get("id");

    const wabaName = wabaNameProp ?? getWabaName(integrationListNewStructure, Number(id), "WhatsApp Business");

    return (
        <Box className={`${styles.callPermissionRequestTemplateContainer} ${fullWidth ? styles.callPermissionRequestTemplateContainerFullWidth : ""}`}>
            
            <Box className={styles.callPermissionContainer}>
                <Box className={styles.callIconContainer}>
                    <CallIcon className={styles.callIcon} />
                </Box>

                <Box className={styles.callPermissionRequestTemplateTextContainer}>
                    <Typography className={styles.callPermissionRequestTemplateTitle}>
                        Can {wabaName} call you?
                    </Typography>

                    <Typography className={styles.callPermissionRequestTemplateDescription}>
                        You can update your preference anytime in the businness profile
                    </Typography>
                </Box>
            </Box>

            <Divider className={styles.callPermissionRequestTemplateDivider} />

            <GlobalButton
                className=""
                sx={{ ...commonButtonStyle, cursor: "default", ...(fullWidth && { maxWidth: "100%" }), ...(variant === "primary" && { color: `${primaryColor} !important` }) }}
                buttonText="Choose preference"
                endIcon={<KeyboardArrowDownIcon />}
                onClick={() => {}}
            />
        </Box>
    );
};

export default CallPermissionRequestPreview;
